module.exports = __webpack_public_path__ + "fonts/d6bbb7c.woff2";